import React from 'react'
import imgPhone from "../../../assets/img/costcall/1/phone.png";
import img1 from "../../../assets/img/costcall/1/1.png";
import img2 from "../../../assets/img/costcall/1/2.png";
import imgPlanet from "../../../assets/img/costcall/1/planet.png";
import classes from "./First.module.scss"

const First = () => {
    return (
        <div className={[classes.first, ""].join(" ")}>
            <div className={[classes.firstBody, ""].join(" ")}>
                <div className="container">
                    <div className={[classes.firstContent, ""].join(" ")}>
                        <div className={[classes.firstContentLeft, ""].join(" ")}>
                            <div className={[classes.firstContentLeftTop, ""].join(" ")}>
                                <div className={[classes.firstContentLeftTopItem, ""].join(" ")}>
                                    Быстро
                                </div>
                                <div className={[classes.firstContentLeftTopItem, ""].join(" ")}>
                                    Безопасно
                                </div>
                                <div className={[classes.firstContentLeftTopItem, ""].join(" ")}>
                                    Надежно
                                </div>
                            </div>
                            <h1 className={[classes.firstContentLeftTitle, ""].join(" ")}>
                                Лучший VPN для
                                использования
                                во всех странах
                            </h1>
                            <div className={[classes.firstContentLeftBottom, ""].join(" ")}>
                                <a href='#' className={[classes.firstContentLeftBottomItem, ""].join(" ")}>
                                    <img src={img1} alt="" />
                                    <div className={[classes.firstContentLeftBottomItemWrap, ""].join(" ")}>
                                        <span>Скачать в </span>
                                        <span>Google play</span>
                                    </div>
                                </a>
                                <a href='#' className={[classes.firstContentLeftBottomItem, ""].join(" ")}>
                                    <img src={img2} alt="" />
                                    <div className={[classes.firstContentLeftBottomItemWrap, ""].join(" ")}>
                                        <span>Скачать в </span>
                                        <span>APPLE STORE</span>
                                    </div>


                                </a>
                            </div>


                        </div>
                        <div className={[classes.firstContentRight, ""].join(" ")}>
                            <img src={imgPhone} alt="" />
                        </div>

                    </div>

                </div>
            </div>

        </div>

    )
}

export default First